export const isAdmin = (role) => ['ADMIN', 'BWADMIN'].includes(role)
